// extracted by mini-css-extract-plugin
export var header = "_sq-1";
export var maskBottom = "_sq-6";
export var maskMiddle = "_sq-7";
export var maskTop = "_sq-5";
export var root = "_sq-0";
export var scrollDownButton = "_sq-3";
export var scrollDownButtonHidden = "_sq-4";
export var viewport = "_sq-2";